module.exports = __webpack_public_path__ + "static/media/bg-hotel-city.dbb7aa50.jpg";